import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "tss-react/mui";
import { styled } from "@mui/material/styles";

const useStyles = makeStyles()((theme) => ({
  title: {
    flexGrow: 1,
    marginTop: 300,
  },
  logoSpan: {
    width: 80,
    marginRight: 20,
  },
}));

const Item = styled("div")(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: "center",
  color: theme.palette.text.primary,
}));

const NoAccessPage = () => {
  const { classes } = useStyles();

  return (
    <div>
      <Item className={`${classes.marginTop20}`}>
        <h1 className={classes.title}>403: Access to this page is restricted</h1>
        <p style={{ textAlign: "center" }}>
          You don't seem to have access to this page. Please try going back to the previous page, or contact us at{" "}
          <a href="mailto:partnerdd@wso2.com">partnerdd@wso2.com</a> for assistance.
        </p>
      </Item>
    </div>
  );
};

export default NoAccessPage;
